// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__13BYH","info":"Note_info__3qIic","note":"Note_note__1Kfbb","actions":"Note_actions__3VmVS"};